export enum AppCardTableHeaderWidthValues {
	Fill = "fill",
}
